<template>
  <div class="page-add">
    <div class="add-title">中组部选调班详情</div>
    <InfoRow :infoList="[
      ['班级名称：', classInfo.className],
      ['主办单位：', classInfo.organizer],
      ['班级类型：', classInfo.trainTypeName],
      ['办班级别：', classInfo.classLevelName],
      ['报名部门：', classInfo.enrollDeptNames],
      [
        '报名时间：',
        classInfo.enrollStartTime ? `${classInfo.enrollStartTime}~${classInfo.enrollEndTime}` : '',
      ],
      ['班级专职管理员：', classInfo.auditUserName],
      ['学期：', classInfo.classSemesterName],
      ['报到时间：', classInfo.clockStartTime ? `${classInfo.clockStartTime}~${classInfo.clockEndTime}` : ''],
      ['报到地点：', classInfo.clockPlace],
      ['培训时间：', classInfo.trainStartTime ? `${classInfo.trainStartTime}~${classInfo.trainEndTime}` : ''],
      ['学制：', classInfo.trainDays],
      ['培训地点：', classInfo.trainPlace, 24],
      ['选调要求：', classInfo.desc, 24],
      ['承办单位：', classInfo.undertakeUnit, 24],
      ['计划人数：', classInfo.planStuNum, 24]
    ]" />
    <el-row class="text-center">
      <el-button @click="$router.push({ path: '/centerSelectClass' })" size="small">返回</el-button>
    </el-row>
  </div>
</template>
<script>
import InfoRow from "@/views/centerSelectClass/detail/components/infoRow.vue";
import { classTransferringInfoNew } from "@/api/studyService";
export default {
  props: {},
  components: { InfoRow },
  data() {
    return {
      classInfo: {},
    };
  },
  created() {
    classTransferringInfoNew({ uuid: this.$route.query.id }).then(
      ({ code, data }) => {
        if (code !== 0) return;
        this.classInfo = data;
      }
    );
  },
  methods: {},
};
</script>
